var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect2, _rect3, _circle, _g, _g2, _g3, _path34, _path35, _path36, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 188,
    viewBox: "0 0 275 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.859 104L192.859 109.19L189.69 116L186.859 104Z",
    fill: "#C99728"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.527 104L217.859 109.777L192.006 112L191.859 108.818L208.527 104Z",
    fill: "#EAAE2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.069 96C228.069 96 232.24 94.1786 232.758 91.0896C234.41 81.4622 215.271 67.5382 212.629 70.3737C209.988 73.2092 214.991 86.7596 214.991 86.7596L228.069 96ZM226.977 94.1252L216.773 86.9331C216.773 86.9331 212.315 75.2174 214.37 73.0157C216.424 70.814 231.912 82.8099 230.622 90.309C230.212 92.7108 226.977 94.1252 226.977 94.1252Z",
    fill: "#EAAE2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.19 118L234.859 99.566L205.093 76L193.859 87.9267L217.19 118Z",
    fill: "#FFC64A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.859 75.8853L204.716 72L189.859 87.2007L193.473 88L204.859 75.8853Z",
    fill: "#EAAE2B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.859 105.522C185.859 105.522 181.882 104.368 181.859 105.492C181.837 106.617 185.859 105.522 185.859 105.522Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.859 110.417C187.859 110.417 183.601 109.071 183.872 111.217C184.142 113.363 187.859 110.417 187.859 110.417Z",
    fill: "#DBDBDB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.859 110C181.859 110 178.282 110.31 178.94 111.653C179.598 112.997 181.859 110 181.859 110Z",
    fill: "#DBDBDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.859 114C181.859 114 178.174 114.897 178.973 116.601C179.771 118.305 181.859 114 181.859 114Z",
    fill: "#DBDBDB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.859 108.031C178.859 108.031 174.371 107.78 174.903 108.711C175.435 109.641 178.859 108.031 178.859 108.031Z",
    fill: "#DBDBDB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.859 113C175.859 113 172.12 113.692 172.991 114.759C173.862 115.826 175.859 113 175.859 113Z",
    fill: "#DBDBDB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M188.859 116C188.859 116 185.895 118.218 187.184 118.911C188.474 119.605 188.859 116 188.859 116Z",
    fill: "#DBDBDB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.619 126C184.619 126 182.71 130.102 184.944 129.998C187.178 129.894 184.619 126 184.619 126Z",
    fill: "#DBDBDB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187.346 122C187.346 122 184.501 124.807 186.682 124.992C188.863 125.177 187.346 122 187.346 122Z",
    fill: "#DBDBDB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M186.859 115C186.859 115 182.936 116.498 184.063 117.756C185.19 119.014 186.859 115 186.859 115Z",
    fill: "#DBDBDB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.768 120C183.768 120 180.557 123.462 182.465 123.961C184.373 124.46 183.768 120 183.768 120Z",
    fill: "#DBDBDB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M273.55 20.7137C276.741 29.1921 273.666 60.1291 268.987 66.6093C262.017 76.2374 250.021 82.2113 244.606 84.9416C242.247 86.1323 232.774 68.7375 235.277 67.4168C240.733 64.5291 251.76 57.2824 253.063 55.5922C254.365 53.902 261.144 37.5815 263.763 28.3915C267.282 16.0536 271.947 16.4163 273.55 20.7137Z",
    fill: "#F7A9A0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.883 80.4548C216.999 81.0364 217.286 81.5675 217.705 81.9769C218.124 82.3862 218.655 82.6543 219.226 82.745C218.852 83.6794 218.808 84.7182 219.1 85.6827C219.691 87.3526 222.505 87.1345 222.505 87.1345C222.309 88.1864 222.427 89.2744 222.844 90.2563C223.567 91.7967 226.441 91.9944 226.441 91.9944C226.783 93.0616 227.491 93.9651 228.433 94.5367C231.002 95.9749 234.891 93.7324 237.374 92.3283C239.856 90.9242 245.638 84.5581 246.859 83.4675L238.23 67C238.23 67 225.339 70.0331 222.644 72.1052C220.361 73.8433 216.524 78.2124 216.883 80.4548Z",
    fill: "#F7A9A0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M218.876 82.8814C220.829 80.4958 223.342 78.8259 225.778 77.0102C225.83 76.9705 225.895 77.0566 225.836 77.0964C223.401 78.8723 221.337 81.1121 218.973 82.9874C218.908 83.0338 218.823 82.9411 218.876 82.8814Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M221.888 86.8205C222.419 86.3146 223.016 85.8772 223.664 85.5195C224.322 85.1016 224.993 84.6971 225.665 84.2994C227.015 83.504 228.378 82.7356 229.77 82.0076C229.833 81.9739 229.896 82.0615 229.833 82.0952C228.49 82.8906 227.161 83.7062 225.853 84.5556L223.902 85.8431C223.322 86.2927 222.691 86.6772 222.021 86.989C221.997 87 221.971 87.0029 221.946 86.9971C221.92 86.9913 221.898 86.9773 221.882 86.9574C221.866 86.9375 221.858 86.913 221.859 86.888C221.86 86.863 221.87 86.8391 221.888 86.8205Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M226.87 91.9234C227.334 91.4127 227.871 90.9965 228.459 90.6928L230.242 89.4851C231.429 88.6749 232.615 87.8647 233.775 87.0086C233.829 86.9704 233.896 87.0697 233.836 87.108C232.662 87.987 231.496 88.8812 230.316 89.745L228.573 91.0138C228.068 91.4463 227.504 91.7796 226.903 91.9998C226.895 92.0007 226.887 91.9987 226.88 91.9942C226.873 91.9897 226.867 91.9829 226.864 91.9746C226.86 91.9664 226.859 91.9571 226.86 91.9479C226.861 91.9388 226.864 91.9302 226.87 91.9234Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M256.859 47C255.958 49.452 255.017 51.8767 253.929 54.2538C253.678 54.8754 253.329 55.4507 252.895 55.9565C252.445 56.4409 251.966 56.8958 251.46 57.3187C250.465 58.1565 249.424 58.9329 248.376 59.6821C246.281 61.201 244.105 62.5837 241.922 63.9527C239.74 65.3217 237.531 66.6771 235.301 67.9439H235.268H235.235L228.787 69.9055L225.577 70.9272C225.056 71.1043 224.509 71.2813 224.015 71.4857C223.54 71.7334 223.093 72.0325 222.68 72.3779C220.947 73.7982 219.413 75.4552 218.122 77.3023C217.468 78.194 217.121 79.2809 217.134 80.3945C217.188 80.9265 217.445 81.4155 217.848 81.7567C218.278 82.1024 218.785 82.3362 219.323 82.4378H219.41V82.5264C219.228 83.0969 219.124 83.6907 219.103 84.2904C219.046 84.8947 219.199 85.5002 219.537 86C219.17 85.5108 218.984 84.9057 219.01 84.2904C219.005 83.6775 219.088 83.0671 219.256 82.4787L219.317 82.5809C218.741 82.4872 218.196 82.2536 217.728 81.8998C217.254 81.5225 216.944 80.9693 216.867 80.3605C216.803 79.1674 217.14 77.9877 217.821 77.0162C219.092 75.0942 220.619 73.3633 222.36 71.8739C222.803 71.4816 223.295 71.1496 223.822 70.8863C224.369 70.6479 224.896 70.4776 225.43 70.2869L228.641 69.238L235.081 67.1947H235.008C239.46 64.6406 243.871 61.9775 248.123 59.0964C249.184 58.3744 250.232 57.632 251.233 56.8283C251.732 56.4337 252.209 56.0107 252.661 55.5615C253.078 55.0893 253.42 54.5539 253.676 53.9745C254.817 51.795 255.825 49.3907 256.859 47Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.294 98.3382C101.294 98.3382 98.1217 104.358 88.4082 102.282C78.6946 100.206 67.1738 82.8475 67.1738 82.8475C67.1738 82.8475 85.0779 78.7657 92.6086 84.1713C100.139 89.5768 99.0574 90.9955 101.294 98.3382Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M103.62 98.3382C103.62 98.3382 106.792 104.358 116.506 102.282C126.219 100.206 137.74 82.8475 137.74 82.8475C137.74 82.8475 119.836 78.7657 112.305 84.1713C104.775 89.5768 105.857 90.9955 103.62 98.3382Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.294 144.674C101.294 144.674 98.1217 150.694 88.4082 148.618C78.6946 146.542 67.1738 129.183 67.1738 129.183C67.1738 129.183 85.0779 125.102 92.6086 130.507C100.139 135.913 99.0574 137.331 101.294 144.674Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.62 144.674C103.62 144.674 106.792 150.694 116.506 148.618C126.219 146.542 137.74 129.183 137.74 129.183C137.74 129.183 119.836 125.102 112.305 130.507C104.775 135.913 105.857 137.331 103.62 144.674Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.445,
    y: 56.8516,
    width: 2,
    height: 129.152,
    fill: "#66BB6A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3585 156.327C31.3585 156.327 28.7331 161.309 20.6935 159.591C12.6538 157.872 3.11834 143.505 3.11834 143.505C3.11834 143.505 17.9371 140.127 24.1701 144.601C30.4031 149.075 29.5076 150.249 31.3585 156.327Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.29 156.327C33.29 156.327 35.9153 161.309 43.9549 159.591C51.9946 157.872 61.5301 143.505 61.5301 143.505C61.5301 143.505 46.7113 140.127 40.4783 144.601C34.2453 149.075 35.1408 150.249 33.29 156.327Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3585 120.069C31.3585 120.069 28.7331 125.051 20.6935 123.333C12.6538 121.615 3.11834 107.248 3.11834 107.248C3.11834 107.248 17.9371 103.869 24.1701 108.343C30.4031 112.817 29.5076 113.991 31.3585 120.069Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.29 120.069C33.29 120.069 35.9153 125.051 43.9549 123.333C51.9946 121.615 61.5301 107.248 61.5301 107.248C61.5301 107.248 46.7113 103.869 40.4783 108.343C34.2453 112.817 35.1408 113.991 33.29 120.069Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2422 120.758C31.2422 120.206 31.6899 119.758 32.2422 119.758C32.7945 119.758 33.2422 120.206 33.2422 120.758V185.998H31.2422V120.758Z",
    fill: "#66BB6A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M170.19 158.355C170.19 158.355 167.89 162.721 160.845 161.216C153.8 159.71 145.444 147.12 145.444 147.12C145.444 147.12 158.429 144.16 163.891 148.08C169.353 152.001 168.569 153.03 170.19 158.355Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M171.88 158.355C171.88 158.355 174.18 162.721 181.226 161.216C188.271 159.71 196.627 147.12 196.627 147.12C196.627 147.12 183.641 144.16 178.179 148.08C172.717 152.001 173.502 153.03 171.88 158.355Z",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170.039,
    y: 158.805,
    width: 2,
    height: 27.1899,
    fill: "#66BB6A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 186,
    width: 174,
    height: 2,
    fill: "#66BB6A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 38,
    r: 35,
    fill: "#FFD12E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2007_25096)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 38,
    r: 28,
    fill: "#ECB800"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2007_25096)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.781 72.8304C121.12 72.8304 136.797 57.1546 136.797 37.8176C136.797 18.4805 121.12 2.80469 101.781 2.80469C82.4427 2.80469 66.7656 18.4805 66.7656 37.8176C66.7656 57.1546 82.4427 72.8304 101.781 72.8304ZM129.799 37.8228C129.799 53.2925 117.257 65.8331 101.786 65.8331C86.3151 65.8331 73.7734 53.2925 73.7734 37.8228C73.7734 22.3531 86.3151 9.8125 101.786 9.8125C117.257 9.8125 129.799 22.3531 129.799 37.8228Z",
    fill: "#FFD12E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_2007_25096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 22V26.6005H106.63C107.903 28.1696 108.801 30.0552 109.187 32.1211H114V36.7215H109.187C108.287 41.5321 104.614 45.3657 99.8899 46.4998L109.136 55.747L105.883 59L91 44.115V42.2421H93.2673L93.2487 42.2235C94.8693 42.2358 96.7971 42.2421 96.98 42.2421C100.498 42.2421 103.474 39.9183 104.456 36.7215H91V32.1211H104.456C103.474 28.9243 100.498 26.6005 96.98 26.6005C96.3801 26.6005 96.06 26.6005 96.06 26.6005H91V22H114Z",
    fill: "#FFD12E"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 0L77.4405 9.91106L86 11L77.4405 12.0889L76.5 22L75.5595 12.0889L67 11L75.5595 9.91106L76.5 0Z",
    fill: "#FFF9C4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73 14L73.396 17.604L77 18L73.396 18.396L73 22L72.604 18.396L69 18L72.604 17.604L73 14Z",
    fill: "#FFF9C4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 47L136.083 52.3636L141 53L136.083 53.6364L135.5 59L134.917 53.6364L130 53L134.917 52.3636L135.5 47Z",
    fill: "#FFF9C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2007_25096",
    x: 74,
    y: 10,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2007_25096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2007_25096",
    x: 66.7656,
    y: 2.80469,
    width: 70.0312,
    height: 70.0254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.931667 0 0 0 0 0.316667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2007_25096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_2007_25096",
    x: 91,
    y: 22,
    width: 25,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2007_25096"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2007_25096",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.935417 0 0 0 0 0.354167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2007_25096"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalValue);
export default __webpack_public_path__ + "static/media/total-value.fa6c316ba8de8207aaed53ff2e08a060.svg";
export { ForwardRef as ReactComponent };